import { connect } from "react-redux";
import SiteIncentiveList from "./siteIncentiveList";
import { bindActionCreators } from "redux";
import { getAllIncentives } from "services/redux/salesIncentive/action";

const mapStateToProps = (state) => ({
    incentives : state.SalesIncentiveReducer.getIncentives,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getAllIncentives
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SiteIncentiveList);
